import {h, render} from 'preact';
import Widget from './widget';
import {defaultConfiguration} from './configuration';
import {IConfiguration} from "../typings";
import * as Cookies from 'es-cookie';
import axios from 'axios';
import merge from 'lodash.merge'
import { Guid } from "guid-typescript";

if (window.attachEvent) {
    window.attachEvent('onload', injectChat);
} else {
    window.addEventListener('load', injectChat, false);
}

window.addEventListener('message', function (event){

    //TODO we need to locate the source of event before doing any logic, but we need to know the domain first
    // if (event.origin != "http://child.com") { return; }
    switch(event.data) {
        case "jovin-block-user":
            let guid = Guid.create();
            Cookies.set("__session_biccssf", guid.toString(),{
                expires: new Date(Date.now() + 864e5)

            });
            break;
    }
}, false);

function getUrlParameter(name: string, defaults = '') {
    name = name.replace(/[[]/, '\\[').replace(/[]]/, '\\]');
    let regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
    let results = regex.exec(document.getElementById('botmanWidget').getAttribute('src'));
    return results === null ? defaults : decodeURIComponent(results[1].replace(/\+/g, ' '));
}

function getUserId(conf: IConfiguration) {
    return conf.userId || generateRandomId(conf.test);
}

function generateRandomId(test:number) {
    //return Math.random().toString(36).substr(2, 6);
    const date = new Date();
    const userId = 'W' + date.getTime() + 'E' + String(date.getMilliseconds()).padStart(3, '0') + 'B';
    if (test == 1) {
        return userId + '.TEST';
    }
    return userId;

}

function injectChat() {
    let root = document.createElement('div');
    root.id = 'botmanWidgetRoot';
    document.getElementsByTagName('body')[0].appendChild(root);

    let settings = {};
    try {
        settings = JSON.parse(getUrlParameter('settings', '{}'));
    } catch (e) {
    }



    let  dynamicConf:IConfiguration|any =   window.botmanWidget || {}; // these configuration are loaded when the chat frame is opened
    try {
        const urlObject = new URL(document.location.href);
        const params = urlObject.searchParams;
        const jovinTest = params.get("jovin_test");
        if( parseInt(jovinTest) === 1) {
            dynamicConf.test = 1
        }
    } catch (e) {
    }


    dynamicConf.userId = getUserId({...defaultConfiguration, ...dynamicConf});

    if (typeof dynamicConf.echoChannel === 'function') {
        dynamicConf.echoChannel = dynamicConf.echoChannel(dynamicConf.userId);
    }
    let endpoint = dynamicConf.endpoint;
    let uuid = dynamicConf.uuid;

    if (endpoint != undefined && uuid != undefined) {
        endpoint = endpoint.replace(/\/$/, "") + '/' + uuid;
        axios.get(endpoint + "/settings/?locale=" + dynamicConf.locale).then((response) => {
            dynamicConf.chatServer = endpoint + "/webhook-logic";
            dynamicConf = {...dynamicConf, ...response.data}
        }).catch(response => {
            console.log(response);
        }).finally(()=>{
            const conf = merge(defaultConfiguration,settings,dynamicConf);

            const iFrameSrc = conf.frameEndpoint;

            render(
                <Widget
                    isMobile={window.screen.width < 500}
                    iFrameSrc={iFrameSrc}
                    conf={conf}
                />,
                root
            );
        });
        return;
    }
    const conf = merge(defaultConfiguration,settings,dynamicConf);

    const iFrameSrc = conf.frameEndpoint;

    render(
        <Widget
            isMobile={window.screen.width < 500}
            iFrameSrc={iFrameSrc}
            conf={conf}
        />,
        root
    );

}

declare global {
    interface Window {
        attachEvent: Function,
        botmanWidget: IConfiguration,
        joypixels: any
    }
}
